import resultPopup from 'assets/images/eventBoatRacingT10/result-popup.png'
import topImagePopup from 'assets/images/eventBoatRacingT10/top-image-popup.png'
import xiaomiredmi14Image from 'assets/images/eventBoatRacingT10/xiaomiredmi14.png'
import iconClose from 'assets/images/eventBoatRacingT10/icon-close.png'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const Header = ({ children, className }) => {
	return (
		<Modal.Header className={className}>
			<img src={topImagePopup} alt="top-image-popup" className='top-image-popup' />
			{children}
		</Modal.Header>
	)
}

const Footer = ({ onClick }) => {
	const { t } = useTranslation()
	return (
		<Modal.Footer className='btn'>
			<button onClick={onClick} className='btn-continue'>
				{t('event.event_boa_racing_t10.see_detail')}
			</button>
		</Modal.Footer>
	)
}

const UserVictory = () => {
	return (<>
		<Header />
		<Modal.Body className='rank-end-content'>
			<div className='items'>
				<div className='items-right'>1st prize</div>
				<div className='items-left'>
					<img src={xiaomiredmi14Image} alt="xiaomi-14" className='rank-end-head-image' />
					<div>
						<p>Mr. David</p>
						<p>0123*****456</p>
					</div>
				</div>
			</div>
		</Modal.Body>
		<Footer />
	</>)
}

const Victory = ({ handle }) => {
	const { t } = useTranslation()

	return (
		<>
			<Header className='victory-announcement-head'>
				<img src={resultPopup} alt="result-popup" className='result-popup-image' />
			</Header>
			<Modal.Body className='victory-announcement-content'>
				<p className='result-popup-text'>
					{t('event.event_boa_racing_t10.congrats_you_have_excellently_won_1st_place_and_get_01_xiaomi_redmi_14c_for_free_unitel_will_contact_you_soon_to_give_you_your_reward')}
				</p>
			</Modal.Body>
			<Footer onClick={handle} />
		</>
	)
}

function VictoryAnnouncement({ show, handleCancel, handle }) {
	return (
		<Modal
			show={show}
			onHide={handleCancel}
			centered
			className='victory-announcement'
		>
			<img src={iconClose} alt="icon-close" className='icon-close' onClick={handleCancel} />
			<Victory handle={handle} />
		</Modal>
	)
}

export default VictoryAnnouncement
